/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/BulkImportPreview/BulkRecordDetailModal.tsx.
 */

import React from "react";
import { createPortal } from "react-dom";
import Button from "../../../../components/common/Button";
import DatasetOverviewFormFlow from "../../../../components/submission/datasetOverview/DatasetOverviewFormFlow";
import "../../../../components/common/ConfirmModal.css";
import "../../Admin/Materials/SubmissionDetail/AdminSubmissionDetail.css";
import "../Stages/Dataset/Dataset.css";
import "./BulkRecordDetailModal.css";
import type { BulkRecordDetail } from "../DataInput/components/BulkImportModal";

/** Type definition — Bulk Record Detail Modal Props. */
export type BulkRecordDetailModalProps = {
  open: boolean;
  recordKey: string;
  materialName?: string;
  subMaterialName?: string;
  detail: BulkRecordDetail | null;
  onClose: () => void;
};

const BulkRecordDetailModal: React.FC<BulkRecordDetailModalProps> = ({
  open,
  recordKey,
  materialName,
  subMaterialName,
  detail,
  onClose,
}) => {
  if (!open) return null;

  const modalContent = (
    <div
      className="modal-overlay bulk-detail-overlay"
      role="dialog"
      aria-modal="true"
    >
      <div className="bulk-detail-modal fade-in">
        <div className="modal-header bulk-detail-modal__header">
          <div className="bulk-detail-modal__heading">
            <h2>Record Details</h2>
            <div className="bulk-detail-modal__chips">
              <span className="bulk-detail-chip bulk-detail-chip--key">{recordKey}</span>
              {materialName && materialName !== "—" && (
                <span className="bulk-detail-chip">{materialName}</span>
              )}
              {subMaterialName && subMaterialName !== "—" && (
                <span className="bulk-detail-chip bulk-detail-chip--muted">
                  {subMaterialName}
                </span>
              )}
            </div>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="modal-body bulk-detail-modal__body">
          {!detail ? (
            <div className="bulk-preview-empty">No details available for this record.</div>
          ) : (
            <div className="admin-detail-root">
              <div className="admin-detail-body dataset-container bulk-detail-container">
                <DatasetOverviewFormFlow submission={detail} />
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer bulk-detail-modal__footer">
          <Button label="Close" onClick={onClose} type="button" variant="default" />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

/** React component — Bulk Record Detail Modal. */
export default BulkRecordDetailModal;
